export default "__VITE_ASSET__CRAFuiLS__"